import styled from "styled-components";

export const ShadowCard = styled.div`
  box-shadow: 0px 2px 2px #0000000d;
  border: 1px solid #f5f4fa;
  border-radius: 4px;
`;
